/* eslint-disable @typescript-eslint/no-unused-vars */
import { IUseLoyaltyRewards, UseLoyaltyRewards } from 'state/loyalty/hooks/types';
import noop from 'utils/noop';

export const updateAppliedRewardsInStorage = noop;

export const removeAppliedRewardsInStorage = noop;

export const useLoyaltyRewards: UseLoyaltyRewards = () => {
  return {
    getAvailableRewardFromCartEntry: _cartEntry => undefined,
  } as IUseLoyaltyRewards;
};
